export const getFreeShippingText = ({ cart, shippingMethods, translate, currencySymbol }) => {
  let freeShippingText = '';

  if (!cart || !shippingMethods?.length || !translate || !currencySymbol) return freeShippingText;

  const { line_items: cartItems } = cart;

  const hasCartPhysicalProduct = cartItems.some(item => item.product_type === 'physical');

  if (!hasCartPhysicalProduct) return freeShippingText;

  const shippingMethodsThreshold = shippingMethods
    .filter(shippingMethod => shippingMethod.type === 'free')
    .map(shippingMethod => shippingMethod.calculator.minimal_amount);

  const minimalFreeShippingAmount = shippingMethodsThreshold.length
    ? Math.min(...shippingMethodsThreshold)
    : 0;

  if (!minimalFreeShippingAmount) return freeShippingText;

  freeShippingText = translate('shipping.free_shipping_threshold', {
    threshold: minimalFreeShippingAmount,
    currencySymbol
  });

  return freeShippingText;
};
